import { Autocomplete, TextField } from '@mui/material'
import * as React from 'react'
import { useMemo } from 'react'
import { useHealthContext } from '../../../../Contexts/Modules/HealthModule/HealthModule'

function TestsField({
  addCollection,
  setAddCollection,
}: {
  addCollection: any
  setAddCollection: any
}) {
  const { mhsTests } = useHealthContext()

  const testOptions = useMemo(() => {
    return (mhsTests.data ?? [])
      .map((test) => ({
        id: test,
        label: test.replace('Panel ', ''),
        type: test.includes('Panel ') ? 'Panels' : 'Tests',
      }))
      .sort((a, b) => -b.id.localeCompare(a.id))
      .sort((a, b) => -b.type.localeCompare(a.type))
  }, [mhsTests])

  const selectedOptions = useMemo(() => {
    return (addCollection?.Tests ? addCollection.Tests.split(', ') : []).map(
      (test: string) => {
        return {
          id: test,
          label: test.replace('Panel ', ''),
          type: test.includes('Panel ') ? 'Panels' : 'Tests',
        }
      },
    )
  }, [addCollection])

  if (addCollection?.DestinationFacilityID === 67) {
    return (
      <Autocomplete
        value={selectedOptions}
        options={testOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionDisabled={(option) => {
          const panelSelected = !!selectedOptions.filter(
            (option: any) => option.type === 'Panels',
          ).length

          if (selectedOptions.map((opt: any) => opt.id).includes(option.id)) {
            return false
          } else if (option.type === 'Panels') {
            return panelSelected || selectedOptions.length > 8
          } else {
            if (panelSelected) {
              return selectedOptions.length > 8
            } else {
              return selectedOptions.length > 16
            }
          }
        }}
        fullWidth
        groupBy={(option) => option.type}
        multiple
        onChange={(e, value) => {
          setAddCollection((c: any) => ({
            ...c,
            Tests: value
              .map((val) => val.id)
              .sort((a, b) => -b.localeCompare(a))
              .sort((a, b) => (a.includes('Panel ') ? -1 : 1))
              .join(', '),
          }))
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Tests"
          />
        )}
      />
    )
  } else {
    return (
      <TextField
        label="Tests"
        id="Tests"
        fullWidth
        onChange={(e) => {
          setAddCollection((c: any) => {
            return {
              ...c,
              Tests: e.target.value,
            }
          })
        }}
        value={addCollection?.Tests}
      />
    )
  }
}

export default TestsField
